<template>
  <v-container fluid class="main-invest-container">
    <v-layout row wrap text-center winners__not-found v-if="serverError">
      <v-flex xs12>
        <h1>{{ serverError }}</h1>
      </v-flex>
      <v-flex xs12 py-0 pb-5>
        <v-divider />
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="!serverError && offer">
      <v-flex xs12>
        <h1>{{ $t("pagesOffer.show.title", { name: offer.name }) }}</h1>
      </v-flex>
      <v-flex xs12 py-0 mb-5>
        <v-divider />
      </v-flex>
      <v-flex xs12 py-0>
        <span @click="$router.go(-1)" class="goback">{{
          $t("pagesOffer.show.gotoBack")
        }}</span>
      </v-flex>

      <v-layout row wrap v-if="fakeBid">
        <v-flex xs12>
          <h1>{{ $t("pagesOffer.show.headerChat") }}</h1>
        </v-flex>
        <v-flex xs12 py-0 mb-5>
          <v-divider />
        </v-flex>
        <v-flex xs12>
          <div class="block">
            <bid-chat :bid="fakeBid" />
          </div>
        </v-flex>
      </v-layout>

      <v-flex xs12 py-0 mb-5 v-if="offer.status == 10">
        <v-flex xs12 py-0 mb-5>
          <v-divider />
        </v-flex>
        <v-flex xs12 py-0>
          <v-btn
            class="mr-2"
            :loading="!isLoaded"
            :disabled="!isLoaded"
            color="green"
            dark
            x-large
            @click="openVerifieldModal()"
            >{{ $t("pagesOffer.show.actions.verified") }}</v-btn
          >

          <v-btn
            class="mr-2"
            color="deep orange"
            dark
            x-large
            :loading="!isLoaded"
            :disabled="!isLoaded"
            @click="openNotVerifieldModal()"
            >{{ $t("pagesOffer.show.actions.noVerified") }}</v-btn
          >

          <v-btn
            color="red"
            dark
            x-large
            @click="openBlockVerifieldModal()"
            :loading="!isLoaded"
            :disabled="!isLoaded"
            >{{ $t("pagesOffer.show.actions.decline") }}</v-btn
          >
        </v-flex>

        <v-flex xs12 py-0 my-5>
          <v-divider />
        </v-flex>
      </v-flex>

      <v-flex xs12>
        <h1>{{ $t("pagesOffer.show.h1") }}</h1>
      </v-flex>
      <v-flex xs12 py-0 mb-5>
        <v-divider />
      </v-flex>
      <v-flex xs12 pt-0>
        <invest-info :offer="offer"></invest-info>
      </v-flex>
    </v-layout>

    <v-dialog v-model="createVerifiedModal" max-width="600px" persistent>
      <v-layout row wrap modal__block>
        <span class="modal__close" @click="closeVerifieldModal"></span>
        <v-flex xs12 modal__wrapper pt-10 style="min-height: 400px">
          <v-flex shrink>
            <v-select
              v-model="ratingModel"
              :items="ratingList"
              item-text="title"
              item-value="value"
              menu-props="overflowY"
              class="mt-0 pt-0"
              hide-details
              :label="$t('pagesOffer.show.selectRating')"
              cchange="change"
              clearable
            ></v-select>
          </v-flex>
          <v-btn
            class="mt-5"
            :loading="!isLoaded"
            @click="sendConfirm"
            :disabled="!ratingModel"
            x-large
            style="color: white"
            color="green"
            >{{ $t("pagesOffer.show.actions.verified") }}</v-btn
          >
        </v-flex>
      </v-layout>
    </v-dialog>

    <v-dialog v-model="createNotVerifiedModal" max-width="600px" persistent>
      <v-layout row wrap modal__block>
        <span class="modal__close" @click="closeVerifieldModal"></span>
        <v-flex xs12 modal__wrapper pt-10 style="min-height: 400px">
          <v-flex shrink>
            <textarea
              v-model="comment"
              outlined
              :label="$t('pagesOffer.show.comment')"
              :placeholder="$t('pagesOffer.show.comment')"
              filled
              class="show-offer-comment elevation-3 pa-2"
            ></textarea>
          </v-flex>
          <v-btn
            class="mt-5"
            :loading="!isLoaded"
            @click="sendConfirm"
            :disabled="!comment"
            x-large
            style="color: white"
            color="deep orange"
            >{{ $t("pagesOffer.show.actions.noVerified") }}</v-btn
          >
        </v-flex>
      </v-layout>
    </v-dialog>

    <v-dialog v-model="createBlockVerifiedModal" max-width="600px" persistent>
      <v-layout row wrap modal__block>
        <span class="modal__close" @click="closeVerifieldModal"></span>
        <v-flex xs12 modal__wrapper pt-10 style="min-height: 400px">
          <v-flex shrink>
            <textarea
              v-model="comment"
              outlined
              :label="$t('pagesOffer.show.comment')"
              :placeholder="$t('pagesOffer.show.comment')"
              filled
              class="show-offer-comment elevation-3 pa-2"
            ></textarea>
          </v-flex>
          <v-btn
            class="mt-5"
            :loading="!isLoaded"
            @click="sendConfirm"
            :disabled="!comment"
            x-large
            style="color: white"
            color="red"
            >{{ $t("pagesOffer.show.actions.decline") }}</v-btn
          >
        </v-flex>
      </v-layout>
    </v-dialog>

    <!-- <v-layout align-start justify-start row wrap filters v-if="!serverError">
      <v-flex shrink>
        <div class="winners__date">
          <v-menu
            ref="date_from"
            v-model="date_from"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="winners_date_from"
                placeholder="Дата"
                prepend-icon="event"
                v-on="on"
                v-on:blur="formatDateFrom"
                v-mask="'##.##.####'"
                class="pt-0 mt-0"
                readonly
                return-masked-value
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              v-model="winnersDateFrom"
              :max="new Date().toISOString().substr(0, 10)"
              @change="saveDateFrom"
              locale="ru-ru"
              first-day-of-week="1"
              no-title
            ></v-date-picker>
          </v-menu>
        </div>
      </v-flex>

      <v-divider vertical></v-divider>
      <v-flex shrink>
        <v-select
          v-model="filterUserSelectModel"
          :items="filterUserSelectList"
          iitem-text="name"
          menu-props="overflowY"
          class="mt-0 pt-0"
          hide-details
          @change="changeUserFilter"
        ></v-select>
      </v-flex>
    </v-layout> -->
  </v-container>
</template>

<script>
// import { mapGetters, mapState } from "vuex";
import { apiCallTrue } from "@/utils/api";
import formatPrice from "@/mixins/filters/formatPrice";
import statusNames from "@/utils/data/statuses";
import showNotify from "@/services/noty";
import InvestInfo from "@/components/invest/Info";
import BidChat from "@/components/bids/chat";

export default {
  name: "OfferShow",
  //directives: { mask },
  mixins: [formatPrice],
  data: () => ({
    isLoaded: true,
    serverError: null,
    offer: null,
    statusNames,

    createVerifiedModal: false,
    createNotVerifiedModal: false,
    createBlockVerifiedModal: false,

    ratingList: [
      { title: "D", value: 10 },
      { title: "DD", value: 20 },
      { title: "DDD", value: 30 },
      { title: "CCC", value: 60 },
      { title: "B-", value: 70 },
      { title: "B", value: 80 },
      { title: "B+", value: 90 },
      { title: "BB-", value: 100 },
      { title: "BB", value: 110 },
      { title: "BB+", value: 120 },
      { title: "BBB-", value: 130 },
      { title: "BBB", value: 140 },
      { title: "BBB+", value: 150 },
      { title: "A-", value: 160 },
      { title: "A", value: 170 },
      { title: "A+", value: 180 },
      { title: "AA-", value: 190 },
      { title: "AA", value: 200 },
      { title: "AA+", value: 210 },
      { title: "AAA", value: 220 },
    ],
    ratingModel: null,
    status: null,
    comment: null,
  }),
  components: { InvestInfo, BidChat },

  computed: {
    fakeBid() {
      if (this.offer) {
        let tmpBid = Object.assign({}, this.offer);
        tmpBid.status = 60;
        return tmpBid;
      }
      return null;
    },
  },

  methods: {
    __clearModalVariable() {
      this.ratingModel = null;
      this.status = null;
      this.comment = null;
    },
    openVerifieldModal() {
      this.createVerifiedModal = true;
      this.__clearModalVariable();
      this.status = 40;
    },
    openNotVerifieldModal() {
      this.createNotVerifiedModal = true;
      this.__clearModalVariable();
      this.status = 0;
    },
    openBlockVerifieldModal() {
      this.createBlockVerifiedModal = true;
      this.__clearModalVariable();
      this.status = 30;
    },
    closeVerifieldModal() {
      this.createVerifiedModal = false;
      this.createNotVerifiedModal = false;
      this.createBlockVerifiedModal = false;
      this.__clearModalVariable();
    },
    // ratingListSortable() {
    //   return this.ratingList.sort((a, b) => {
    //     if (a.title > b.title) {
    //       return 1;
    //     }
    //     if (a.title < b.title) {
    //       return -1;
    //     }
    //     // a должно быть равным b
    //     return 0;
    //   });
    // },
    async sendConfirm() {
      const url = `v1/invest/offers/${this.offer.id}/verified-result`;
      const data = {
        status: this.status,
        rating: this.ratingModel,
        comment: this.comment,
      };

      this.isLoaded = false;
      this.serverError = null;

      await apiCallTrue({ url, method: "POST", data })
        .then(() => {
          // this.offer = response.data.data;
          this.$router.go(-1);
        })
        .catch((error) => {
          console.log("ERROR", error);
          //this.serverError = error.message;
          showNotify("error", error);
        })
        .finally(() => {
          this.isLoaded = true;
        });
    },
    currencyInvestIcon(currency) {
      if (currency == "USD") return "mdi-currency-usd";
      return "mdi-currency-rub";
    },

    getSubTypeName(id) {
      if (!id) return;
      let statusObj = this.__getStatusObj("investSubtype");
      if (!statusObj) return;
      return statusObj[id].name ? statusObj[id].name : "";
    },

    getTypeName(id) {
      if (!id) return;
      let statusObj = this.__getStatusObj("invest");
      if (!statusObj) return;
      return statusObj[id].name ? statusObj[id].name : "";
    },

    getStatusParam(id, param) {
      if (id === null) return;
      if (!param) return;
      let statusObj = this.__getStatusObj("investStatus");
      if (!statusObj) return;
      return statusObj[id][param] ? statusObj[id][param] : "";
    },

    __getStatusObj(objName) {
      if (!this.statusNames) return null;
      if (this.statusNames[objName]) return this.statusNames[objName];
      return null;
    },

    async getOffer(id) {
      const url = `v1/invest/offers-moderation-show/${id}`;

      this.isLoaded = false;
      this.serverError = null;

      await apiCallTrue({ url })
        .then((response) => {
          this.offer = response.data.data;
        })
        .catch((error) => {
          console.log("ERROR", error);
          this.serverError = error.message;
          showNotify("error", error);
        })
        .finally(() => {
          this.isLoaded = true;
        });
    },
  },
  mounted() {
    const { id } = this.$route.params;
    this.getOffer(id);
  },
};
</script>

<style lang="scss" scoped>
textarea.show-offer-comment {
  border: 1px solid #e6e6e6;
  width: 100%;
  min-height: 128px;
}
</style>
